export function localeString() {
  const kComBizSpa = window.localStorage.kComBizSpa
  return kComBizSpa ? JSON.parse(kComBizSpa).locale : null
}
